import React , { useRef }from 'react';
import './ContCard.css';
import ContCardimg from '../../Assets/ContCard.gif';

function ContCard() {
  const marqueeRef = useRef(null); 

  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop();
    }
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start();
    }
  }
  return (
    <div className='ContCard'>
      <div className='C_Card1'>
            <div className='c_Card_Head'>
                <h4 className='c_Card_H4'>NEWS & ANNOUCEMENTS</h4>
            </div>
            <div className='Cont-Card-Working'
             onMouseOver={handleMouseOver} 
             onMouseOut={handleMouseOut}  
            >
              <marquee scrollamount='3' ref={marqueeRef}  direction="up">
              <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#">
                 Abdali Institute of Nursing & Health Sciences, Karachi. (Download Admit Card).</a> 
                  </p>
                  <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#">
                 SSPDS | Sindh Social Protection Authority |Social Protection Department | Government of Sindh. (Application Status Eligible/Rejected Candidate List).</a> 
                  </p>
                  <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#">
                 The Rising Star Public Secondary School (Admissions/Scholarship Test) Result Announced</a> 
                  </p>
                  <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#">
                 Sindh Testing Service Pakistan (Karachi Office-Job Opportunity)</a> 
                  </p>
                  <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#"> 
                 Congratulations! STS is the Premier Testing Service to conduct (CBT) computer-based test/online test for recruitment & admissions simultaneously in all Provinces of Pakistan.</a> 
                  </p>
              </marquee>
            </div>
      </div>

      <div className='C_Card1'>
            <div className='c_Card_Head'>
                <h4 className='c_Card_H4'>NEW PROJECTS</h4>
            </div>
            <div className='Cont-Card-Working'>   
              <p> 
                  <img className='C_Card_img' src={ContCardimg} alt="" />
                 <a className='C_Card_a' href="#">
                 THE RISING STAR PUBLIC SCHOOL & COLLEGE</a> 
                  </p> 
            </div>
      </div>

      <div className='C_Card1'>
            <div className='c_Card_Head'>
                <h4 className='c_Card_H4'>TEST CONDUCT</h4>
            </div>
            <div className='Cont-Card-Working Cont_Card3'>
              <h5>Educational Test</h5>
              <p>
              Medical College Admissions Test (MCAT) <br />
              Business College Admissions Test (BCAT) <br />
              Engineering College Admissions Test (ECAT) <br />
              </p>
              <h5>Professional Test</h5>
              <p>
              Teacher Assessment Test (TAT) <br />
              Management & Administrations Assessment Test <br />
              Recruitment Screening Test (RST) <br />
              </p>
              <h5>Assessment Test</h5>
              <p>
              Ability Assessment Test (AAT) <br />
              Pakistan Graduate Assessment Test (PGAT) (Laws) <br />
              Schools Assessment Test (Teachers/Students) (SAT) <br />
              </p>
            </div>   
      </div>
    </div>
  )
}

export default ContCard
